// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__DbPIr","dense":"_type_dense__13yj_"};